import { LearningResourceFeePriceDto } from './learningresourcefeepricedto';
import { PaginationFeaturesDto } from './paginationfeaturesdto';

export class LearningResourceFeePriceRequest {

    learningResourceFeePriceDto: LearningResourceFeePriceDto = new LearningResourceFeePriceDto();

    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}